import {forwardRef, useContext} from 'react';

import DateSelectContext from '../context';
import ButtonClear from './ButtonClear';
import ButtonToday from './ButtonToday';
import DateSelectCalendar from './DateSelectCalendar';
import DateSelectMonth from './DateSelectMonth';
import DateSelectTime from './DateSelectTime';

const DateSelectPanel = forwardRef<HTMLDivElement>((_, ref) => {
    const {showTime} = useContext(DateSelectContext);

    return (
        <div
            className="pointer-events-auto mx-auto min-w-[17rem] max-w-[17rem] overflow-hidden p-3 text-light-primary"
            ref={ref}
            role="dialog"
            tabIndex={-1}
        >
            <div className="space-y-2">
                <DateSelectMonth />
                <DateSelectCalendar />
                <ButtonToday />
                <ButtonClear />
                {showTime && <DateSelectTime />}
            </div>
        </div>
    );
});

DateSelectPanel.displayName = 'DateSelectPanel';

export default DateSelectPanel;
